export default {
    mainContainer: {
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent:'center', 
        gap: '10px'
    },
    actionButton: {
        width: '100%', 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'center', 
        padding: '10px 20px'
    }
}